import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // basic styles
import "swiper/css/navigation"; // optional: navigation buttons
import "swiper/css/pagination"; // optional: pagination
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {
  IoNotificationsOutline,
  IoBagAddOutline,
  IoSearchOutline,
  IoArrowBackOutline,
  IoArrowForwardOutline,
  IoTrash,
  IoCloseSharp,
  IoSettings,
} from "react-icons/io5";
import Select from "react-select";
import Swal from "sweetalert2";

import { CountdownTimer } from "../components/CountDownTimer";
import { Navigation, Autoplay } from "swiper/modules";
import "./Navbar.css"; // Import the CSS file for this component
import { BASE_URL } from "../Pages/Config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faSearch } from "@fortawesome/free-solid-svg-icons";

import { formatDate } from "../components/dateUtils";

export default function Navbar() {
  const [showdropdown, setshowDropdown] = useState(null);
  const [sessionuser, setUser] = useState(null);
  const [userdata, setUserdata] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const userId = Cookies.get("user_id");
  const [openMassboxIndex, setOpenMassboxIndex] = useState(null);

  const [open, setOpen] = useState(false);

  const showSettings = () => {
    setshowDropdown(true);
  };

  const hideSettings = () => {
    setOpen(false);
  };

  const toggleMassbox = (index) => {
    setOpenMassboxIndex(openMassboxIndex === index ? null : index);
  };

  useEffect(() => {
    const checkLogin = async () => {
      const user_id = Cookies.get("user_id");

      if (!user_id) {
        Cookies.remove("user_id");
        Cookies.remove("username");
        Cookies.remove("token");
        localStorage.clear();
        sessionStorage.clear();
      } else {
      }
    };

    checkLogin();
  }, []);

  const userName = Cookies.get("username");

  useEffect(() => {
    // console.log("Making API request...");
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userId}&t=${Date.now()}`)
      .then((res) => {
        // console.log("API response:", res.data.data); // Check the full response
        if (res.data.success) {
          setUserdata(res.data.data);
          setUser(res.data.data);
        } else {
          // console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => {
        // console.error("API request failed:", err);
        if (err.response) {
          console.error("Response error:", err.response);
        } else if (err.request) {
          console.error("No response received:", err.request);
        } else {
          console.error("Request setup error:", err.message);
        }
      });
  }, []);

  // console.log(userdata);

  // State to control sidebar visibility
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the sidebar
  const sidemenu = () => {
    setIsOpen(!isOpen);
  };

  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive(!isActive); // toggle active state
  };

  const logout = () => {
    Cookies.remove("user_id");
    Cookies.remove("username");
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    window.location.reload(); // Force refresh after navigation
    toast.success("LogOut Successfully!!");
  };

  const faileduser = () => {
    Cookies.remove("user_id");
    Cookies.remove("username");
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    window.location.reload(); // Force refresh after navigation
    toast.warning("Your session is no longer valid. Please log in again. ");
  };
  const [bookmarks, setBookmarks] = useState([]);

  const fetchBookmarks = async () => {
    const user_id = Cookies.get("user_id");
    if (!user_id) {
      // console.error("User ID not found in cookies.");

      return;
    }

    try {
      const res = await fetch(
        `${BASE_URL}/all_fav_item.php?id=${user_id}&t=${Date.now()}`,
        {
          cache: "no-store",
        },
      );

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      //console.log("Fetched data:", data);

      if (data.success) {
        setBookmarks(data.data);
      } else {
        setBookmarks([]);
      }
    } catch (err) {
      console.error("Error fetching bookmarks:", err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookmarks(); // initial call

    const interval = setInterval(() => {
      fetchBookmarks();
    }, 5000); // every 5 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  const [searchword, setSearchword] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [recentSearches, setRecentSearches] = useState([]);

  const [suggestions, setSuggestions] = useState([]);

  const fetchSuggestions = async (query) => {
    if (!query.trim()) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(
        `${BASE_URL}/all_items_by_search.php?search=${encodeURIComponent(
          query,
        )}`,
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setSuggestions(response.data.data);

        //console.log("dropdown", response.data.data);
        setShowDropdown(true);
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    } catch (err) {
      console.error("Error fetching suggestions", err);
      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("recentSearches")) || [];
    setRecentSearches(stored);
  }, []);

  const saveRecentSearch = (value) => {
    let updated = [value, ...recentSearches.filter((item) => item !== value)];
    if (updated.length > 5) updated = updated.slice(0, 5);
    setRecentSearches(updated);
    localStorage.setItem("recentSearches", JSON.stringify(updated));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchword(value);
    setShowDropdown(true);
    fetchSuggestions(value);
  };

  const handleSuggestionClick = (item) => {
    const value = item.title || item;

    setSearchword(value);
    saveRecentSearch(value);
    setShowDropdown(false);

    const params = new URLSearchParams();

    if (value) params.append("q", value);
    if (selectedLocation) params.append("location", selectedLocation);

    navigate(`/search?${params.toString()}`);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchword.trim()) params.append("q", searchword.trim());
    if (selectedLocation) params.append("location", selectedLocation);

    navigate(`/search?${params.toString()}`);
  };

  const [NewADD, setNewADD] = useState([]);

  useEffect(() => {
    const fetchNewlyAddProducts = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/newly_add.php?type=limit&t=${Date.now()}`,
        );

        //  console.log("Newly Add", response.data);

        if (response.data.success) {
          setNewADD(response.data.new_add);
        } else {
          setNewADD([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setNewADD([]);
      }
    };

    const intervalId = setInterval(fetchNewlyAddProducts, 4000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  const [messageType, setMessageType] = useState("Whatsapp");

  const [itemid, setitemid] = useState("");
  const [duration, setDuration] = useState("3");

  const [reminderloader, setreminderloader] = useState(false);

  const handleSetReminder = async (itemId, index) => {
    try {
      setreminderloader(true);
      const formData = new FormData();
      const user_id = Cookies.get("user_id");
      formData.append("item_id", itemId);
      formData.append("message_type", messageType || "Whatsapp");
      formData.append("duration", duration || "3");
      formData.append("user_id", user_id || "0");

      const response = await axios.post(
        `${BASE_URL}/set_reminder.php`,
        formData,
      );

      //    console.log(response);

      if (response.data.success) {
        toast.success("Reminder set successfully!");
        Swal.fire({
          title: "Reminder Set!",
          icon: "success",
          timer: 2000, // auto close after 2 seconds (2000 ms)
          showConfirmButton: false,
        });

        fetchUserReminders();

        setreminderloader(false);
        setOpenMassboxIndex(null);
        setIsActive(false);

        window.location.reload();
      } else {
        fetchUserReminders();
        toast.error("Failed to set reminder.");
        setreminderloader(false);
        setIsActive(false);
      }
    } catch (error) {
      console.error("Error setting reminder:", error);
      toast.error("Failed to set reminder. Try again later!");
      setreminderloader(false);
      setIsActive(false);
    }
  };

  const stopreminder = async (itemId, index) => {
    // 🟡 Show confirmation alert
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to stop this reminder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, stop it!",
      cancelButtonText: "Cancel",
    });

    // ❌ If user cancels
    if (!result.isConfirmed) {
      return;
    }

    try {
      setreminderloader(true);

      const formData = new FormData();
      const user_id = Cookies.get("user_id");

      formData.append("item_id", itemId);
      formData.append("message_type", messageType || "Whatsapp");
      formData.append("duration", duration || "3");
      formData.append("user_id", user_id || "0");
      formData.append("type", "stop");

      const response = await axios.post(
        `${BASE_URL}/set_reminder.php`,
        formData,
      );

      console.log(response);

      if (response.data.success) {
        toast.success("Reminder removed successfully!");
        Swal.fire({
          title: "Reminder Removed!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchUserReminders();
        // setIsActive(false);
        setOpenMassboxIndex(null);

        window.location.reload();
      } else {
        toast.error("Failed to remove reminder.");
      }
    } catch (error) {
      console.error("Error removing reminder:", error);
      toast.error("Failed to remove reminder. Try again later!");
    } finally {
      setreminderloader(false);
    }
  };

  const [category, setcategory] = useState([]); // ✅ FIXED

  // Get All Categorys
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_category.php?t=${Date.now()}`)
      .then((res) => {
        // console.log("Full response:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setcategory(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setcategory([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setcategory([]);
      });
  }, []);

  const [NotificationCount, SetNotificationCount] = useState("");

  useEffect(() => {
    const updateNotifications = async () => {
      const user_id = Cookies.get("user_id");

      try {
        const res = await fetch(
          `${BASE_URL}/mark_seen_notification.php?user_id=${user_id}&type=count&t=${Date.now()}`,
          { cache: "no-store" },
        );

        const data = await res.json(); // ✅ Parse response

        //  console.log("Full response:", data);

        if (data.success) {
          SetNotificationCount(data.count);
          //  console.log("Notification Count:", data.count);
        } else {
          console.log("Error:", data.message);
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    updateNotifications();
  }, []);

  const [userCharges, setUserCharges] = useState(0);

  useEffect(() => {
    const updateNotifications = async () => {
      const user_id = Cookies.get("user_id");

      try {
        const res = await fetch(
          `${BASE_URL}/user_charges_count.php?user_id=${user_id}&t=${Date.now()}`,
          { cache: "no-store" },
        );

        const data = await res.json();
        // console.log("Charges Total:", data);

        if (data.success) {
          setUserCharges(data.unpaid_total || 0); // ✅ Update state
          //  console.log("Charges Unpaid Amount:", data.unpaid_total);
        } else {
          //   console.log("Error:", data.message);
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    updateNotifications();
  }, []);

  // ✅ Show popup when userCharges updates
  useEffect(() => {
    if (userCharges > 10) {
      showChargesPopup(userCharges);
    }
  }, [userCharges]);

  function showChargesPopup(userCharges) {
    const lastShown = localStorage.getItem("chargesPopupLastShown");
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000;

    if (userCharges > 0 && (!lastShown || now - lastShown > oneDay)) {
      Swal.fire({
        icon: "info",
        title:
          "<h3 style='color:#f4b74d; font-weight:bold;'>💰 Pending Charges</h3>",
        html: `
        <p style="font-size:16px; color:#333;">
          You have <b style="color:#d9534f;">${userCharges} SAR</b> pending charges.
        </p>
        <p style="font-size:14px; color:#666;">
          Please clear your charges to continue enjoying auctions ⚡
        </p>
      `,
        background: "linear-gradient(135deg, #fffbe6, #fff3cd)",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Pay Now",
        denyButtonText: "View Charges",
        cancelButtonText: "Later",
        confirmButtonColor: "#28a745",
        denyButtonColor: "#007bff",
        cancelButtonColor: "#6c757d",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.setItem("chargesPayNowClicked", "true");
          window.location.href = `/charges`;
        } else if (result.isDenied) {
          window.location.href = "/charges";
        }
      });

      localStorage.setItem("chargesPopupLastShown", now.toString());
    }
  }

  const [ads, setAds] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_ads.php?type=wishlist&t=${Date.now()}`)
      .then((res) => {
        //   console.log("Ads responsess :", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setAds(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setAds([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setAds([]);
      });
  }, []);

  const [currentAd, setCurrentAd] = useState(0);

  useEffect(() => {
    if (ads.length === 0) return;

    const interval = setInterval(() => {
      setCurrentAd((prev) => (prev + 1) % ads.length);
    }, 15000); // 15000ms = 15 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [ads]);

  const ad = ads[currentAd];

  const [userreminders, setuserreminders] = useState([]);

  const fetchUserReminders = async () => {
    const user_id = Cookies.get("user_id");
    if (!user_id) return;

    try {
      const res = await fetch(
        `${BASE_URL}/user_reminders.php?user_id=${user_id}&t=${Date.now()}`,
        { cache: "no-store" },
      );

      const data = await res.json();
      // console.log("reminders:", data);

      if (data.success) {
        setuserreminders(data.data); // ✅ Correctly updates state
      } else {
        //  console.log("Error:", data.message);
        setuserreminders([]); // clear if no data
      }
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  };

  useEffect(() => {
    fetchUserReminders(); // ✅ call function
  }, []);

  const [locations, setlocation] = useState([]);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_location.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          const sortedData = [...res.data.data].sort((a, b) => {
            return Number(a.order_number) - Number(b.order_number);
          });

          setlocation(sortedData);
        } else {
          console.warn("API success true, but data is not array");
          setlocation([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setlocation([]);
      });
  }, []);

  const options = locations.map((loc) => ({
    value: loc.city_name,
    label: loc.city_name,
  }));

  return (
    <>
      <div className="header-topbar-area">
        <div className="topbar-area">
          <div className="container">
            <div className="topbar-wrap">
              <div className="topbar-left">
                <ul className="contact-area">
                  <li>
                    <Link to="/membership">Membership</Link>
                  </li>
                </ul>
              </div>
              <div className="topbar-right">
                <ul></ul>
                <div className="language-area">
                  <div className="language-btn">
                    {sessionuser ? (
                      <div>
                        <Link to="/#" onClick={logout}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-box-arrow-in-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0z"
                            />
                            <path
                              fillRule="evenodd"
                              d="M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708z"
                            />
                          </svg>
                          <span>Log Out</span>
                        </Link>
                      </div>
                    ) : (
                      <>
                        <Link to="/login" state={{ from: location }} replace>
                          <span>Log In</span>
                        </Link>
                        <span
                          style={{
                            width: "1px",
                            height: "15px",
                            background: "black",
                          }}
                        ></span>
                        <Link to="/register-number">
                          <span>Register</span>
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <header className="header-area style-1 d-flex flex-nowrap align-items-center justify-content-between">
          <div className="nav-left">
            <div className="company-logo">
              <Link to="/">
                <img
                  alt="Logo"
                  className="img-fluid"
                  src={`${BASE_URL}/images/fastrade_logo.jpg`}
                  style={{ width: "110px" }}
                />
              </Link>
            </div>
            <div className={`main-menu ${isOpen ? "sidebar-active" : ""}`}>
              <div className="mobile-logo-area d-lg-none d-flex justify-content-center">
                <div className="mobile-logo-wrap">
                  <Link to="/">
                    <img
                      alt="Logo"
                      className="img-fluid"
                      src={`${BASE_URL}/images/fastrade_logo.jpg`}
                      style={{ width: "110px" }}
                    />
                  </Link>
                </div>
              </div>
              <ul className="menu-list d-lg-none">
                {/* <li className="menu-item-has-children ">
                  <Link to="/" className="drop-down">
                    Home
                  </Link>
                </li> */}
                <li className="menu-item-has-children ">
                  <Link to="/list-an-item" className="drop-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus-lg"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                      />
                    </svg>
                    &nbsp;List an item
                  </Link>
                </li>
                <li className="menu-item-has-children ">
                  <Link to="/wishlist" className="drop-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-heart"
                      viewBox="0 0 16 16"
                    >
                      <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                    </svg>
                    &nbsp;Watch list
                  </Link>
                </li>
                <li className="menu-item-has-children">
                  <Link to="/setting" className="drop-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                    &nbsp;My Fast Trade
                  </Link>
                </li>
                <li className="">
                  <Link to="/notification" className="drop-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-bell"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                    </svg>
                    &nbsp;Notification
                  </Link>
                </li>
                <li className="">
                  <Link to="/mybids" className="drop-down">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hammer" viewBox="0 0 16 16">
  <path d="M9.972 2.508a.5.5 0 0 0-.16-.556l-.178-.129a5 5 0 0 0-2.076-.783C6.215.862 4.504 1.229 2.84 3.133H1.786a.5.5 0 0 0-.354.147L.146 4.567a.5.5 0 0 0 0 .706l2.571 2.579a.5.5 0 0 0 .708 0l1.286-1.29a.5.5 0 0 0 .146-.353V5.57l8.387 8.873A.5.5 0 0 0 14 14.5l1.5-1.5a.5.5 0 0 0 .017-.689l-9.129-8.63c.747-.456 1.772-.839 3.112-.839a.5.5 0 0 0 .472-.334"/>
</svg>
                    &nbsp;My Bids
                  </Link>
                </li>
                <li className="menu-item-has-children ">
                  <Link to="/membership" className="drop-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-star"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                    </svg>
                    &nbsp;Membership
                  </Link>
                </li>
              </ul>
              <ul className="contact-area d-lg-none d-flex">
                <li>
                  <Link to="mailto:fasttrade@gmail.com">
                    <svg
                      width="20"
                      height="16"
                      viewBox="0 0 20 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18.2422 0.96875H1.75781C0.786602 0.96875 0 1.76023 0 2.72656V13.2734C0 14.2455 0.792383 15.0312 1.75781 15.0312H18.2422C19.2053 15.0312 20 14.2488 20 13.2734V2.72656C20 1.76195 19.2165 0.96875 18.2422 0.96875ZM17.996 2.14062L11.243 8.85809C10.9109 9.19012 10.4695 9.37293 10 9.37293C9.53047 9.37293 9.08906 9.19008 8.75594 8.85699L2.00398 2.14062H17.996ZM1.17188 13.0349V2.96582L6.23586 8.00312L1.17188 13.0349ZM2.00473 13.8594L7.06672 8.82957L7.9284 9.68672C8.48176 10.2401 9.21746 10.5448 10 10.5448C10.7825 10.5448 11.5182 10.2401 12.0705 9.68781L12.9333 8.82957L17.9953 13.8594H2.00473ZM18.8281 13.0349L13.7641 8.00312L18.8281 2.96582V13.0349Z"></path>
                    </svg>
                    fasttrade@gmail.com
                  </Link>
                </li>
                <li>
                  <Link to="mailto:support@fasttrade.com.sa">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18.5956 8.7197C18.5244 6.5458 17.6262 4.48105 16.0844 2.94689C14.4584 1.32064 12.2975 0.425323 9.99999 0.425323C5.35968 0.425323 1.56812 4.11876 1.40468 8.7197C1.04688 8.87819 0.742722 9.13705 0.529067 9.46491C0.315412 9.79277 0.201428 10.1756 0.200928 10.5669V12.8363C0.201507 13.3722 0.414645 13.8859 0.793578 14.2649C1.17251 14.6438 1.68629 14.8569 2.22218 14.8575C2.5689 14.8571 2.90131 14.7192 3.14648 14.474C3.39166 14.2288 3.52958 13.8964 3.52999 13.5497V9.85314C3.52999 9.17595 3.01062 8.62376 2.3503 8.55814C2.59405 4.5497 5.93093 1.36282 9.99999 1.36282C12.0475 1.36282 13.9728 2.16095 15.4219 3.61001C16.7525 4.94064 17.5312 6.67501 17.6484 8.55845C16.9887 8.6247 16.4703 9.17657 16.4703 9.85314V13.5494C16.4703 14.2322 16.9978 14.7878 17.6659 14.8456V15.7797C17.6653 16.2855 17.4642 16.7704 17.1065 17.128C16.7488 17.4856 16.2639 17.6867 15.7581 17.6872H14.3453C14.2501 17.4095 14.0702 17.1686 13.8311 16.9983C13.5919 16.8281 13.3054 16.737 13.0119 16.7378H11.5556C11.3466 16.7378 11.1459 16.7822 10.9622 16.8678C10.7161 16.9815 10.5077 17.1632 10.3616 17.3914C10.2154 17.6196 10.1375 17.8849 10.1372 18.1559C10.1372 18.5353 10.285 18.8916 10.5528 19.1581C10.6841 19.2905 10.8403 19.3954 11.0125 19.4669C11.1846 19.5383 11.3692 19.5749 11.5556 19.5744H13.0119C13.6156 19.5744 14.1478 19.1841 14.3462 18.6247H15.7581C17.3272 18.6247 18.6034 17.3484 18.6034 15.7797V14.6788C18.9591 14.5194 19.2612 14.2606 19.4733 13.9337C19.6854 13.6067 19.7985 13.2254 19.7991 12.8356V10.5663C19.7991 9.74314 19.3034 9.03439 18.5956 8.7197ZM2.59218 9.85314V13.5494C2.59218 13.7534 2.42624 13.9197 2.22187 13.9197C1.93454 13.9194 1.65907 13.8051 1.4559 13.6019C1.25273 13.3987 1.13845 13.1233 1.13812 12.8359V10.5666C1.13845 10.2792 1.25273 10.0038 1.4559 9.80061C1.65907 9.59744 1.93454 9.48315 2.22187 9.48282C2.42624 9.48282 2.59218 9.64907 2.59218 9.85314ZM13.4822 18.2566C13.4589 18.3642 13.3995 18.4606 13.3139 18.5299C13.2284 18.5992 13.1217 18.6372 13.0116 18.6375H11.5553C11.4272 18.6375 11.3069 18.5875 11.215 18.4956C11.1703 18.4512 11.1348 18.3984 11.1107 18.3402C11.0865 18.282 11.0742 18.2196 11.0744 18.1566C11.0747 18.0292 11.1255 17.907 11.2156 17.817C11.3057 17.7269 11.4279 17.6762 11.5553 17.6759H13.0116C13.1397 17.6759 13.26 17.7256 13.3516 17.8175C13.4422 17.9078 13.4922 18.0284 13.4922 18.1566C13.4925 18.1909 13.4887 18.2253 13.4822 18.2566ZM18.8616 12.8359C18.8612 13.1233 18.7469 13.3987 18.5438 13.6019C18.3406 13.8051 18.0651 13.9194 17.7778 13.9197C17.6796 13.9196 17.5855 13.8806 17.516 13.8111C17.4466 13.7417 17.4076 13.6476 17.4075 13.5494V9.85314C17.4075 9.64907 17.5734 9.48282 17.7778 9.48282C18.0651 9.48315 18.3406 9.59744 18.5438 9.80061C18.7469 10.0038 18.8612 10.2792 18.8616 10.5666V12.8359Z"></path>
                      <path d="M13.0353 12.9975C13.5619 12.9969 14.0668 12.7875 14.4391 12.4151C14.8115 12.0427 15.0209 11.5379 15.0215 11.0113V6.96406C15.0215 6.43469 14.8146 5.93594 14.439 5.56031C14.0634 5.18469 13.565 4.97781 13.0353 4.97781H6.96464C6.43804 4.97839 5.93316 5.18784 5.56079 5.56021C5.18842 5.93258 4.97897 6.43746 4.97839 6.96406V11.0113C4.97897 11.5379 5.18842 12.0427 5.56079 12.4151C5.93316 12.7875 6.43804 12.9969 6.96464 12.9975H7.00183V14.0463C7.00121 14.1743 7.02592 14.3012 7.07453 14.4197C7.12313 14.5382 7.19468 14.6459 7.28506 14.7366C7.37544 14.8273 7.48287 14.8993 7.60116 14.9484C7.71945 14.9974 7.84627 15.0226 7.97433 15.0225C8.10231 15.0228 8.22903 14.9972 8.34693 14.9475C8.46483 14.8977 8.5715 14.8247 8.66058 14.7328L10.4053 12.9975H13.0353ZM9.88183 12.1963L7.99371 14.0741C7.98527 14.0828 7.97902 14.0894 7.96121 14.0816C7.93964 14.0728 7.93964 14.0588 7.93964 14.0463V12.5288C7.93964 12.4044 7.89026 12.2852 7.80235 12.1973C7.71444 12.1094 7.59521 12.06 7.47089 12.06H6.96496C6.68691 12.0597 6.42035 11.9491 6.22374 11.7525C6.02714 11.5559 5.91654 11.2893 5.91621 11.0113V6.96406C5.91654 6.68602 6.02714 6.41946 6.22374 6.22285C6.42035 6.02624 6.68691 5.91564 6.96496 5.91531H13.0356C13.315 5.91531 13.5778 6.02469 13.7765 6.22313C13.9753 6.42188 14.0843 6.685 14.0843 6.96406V11.0113C14.084 11.2893 13.9734 11.5559 13.7768 11.7525C13.5802 11.9491 13.3136 12.0597 13.0356 12.06H10.2125C10.0884 12.06 9.96964 12.1091 9.88183 12.1963Z"></path>
                      <path d="M7.72281 8.37094C7.34156 8.37094 7.03125 8.68157 7.03125 9.0625C7.03125 9.44344 7.34187 9.75407 7.72281 9.75407C8.10437 9.75407 8.415 9.44344 8.415 9.0625C8.415 8.68157 8.10469 8.37094 7.72281 8.37094ZM9.99969 8.37094C9.61844 8.37094 9.30812 8.68157 9.30812 9.0625C9.30812 9.44344 9.61875 9.75407 9.99969 9.75407C10.3816 9.75407 10.6919 9.44344 10.6919 9.0625C10.6919 8.68157 10.3816 8.37094 9.99969 8.37094ZM12.2766 8.37094C11.8953 8.37094 11.585 8.68157 11.585 9.0625C11.585 9.44344 11.8956 9.75407 12.2766 9.75407C12.6581 9.75407 12.9688 9.44344 12.9688 9.0625C12.9688 8.68157 12.6581 8.37094 12.2766 8.37094Z"></path>
                    </svg>
                    Customer support
                  </Link>
                </li>
              </ul>
              <div
                className="btn-area d-lg-none d-flex"
                style={{
                  flexDirection: "column",
                  gap: "10px",
                  padding: "0px , 6px",
                }}
              >
                {sessionuser ? (
                  <Link
                    to="/#"
                    onClick={logout}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
                      />
                    </svg>
                    Log Out
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
                      />
                    </svg>
                    Log In
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="nav-right d-flex jsutify-content-end align-items-center">
            <div className="middlebar-right">
              <ul>
                <li>
                  <Link to="/list-an-item" style={{ gap: "4px" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus-lg"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                      />
                    </svg>
                    List an item
                  </Link>
                </li>
                <li>
                  <span>|</span>
                  <Link to="#" onClick={handleClick}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-heart"
                      viewBox="0 0 16 16"
                    >
                      <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                    </svg>
                    Watch List
                  </Link>
                </li>
                <li>
                  <span>|</span>

                  <Link
                    to="/setting"
                    className="Quick-acess dropbtn"
                    onMouseEnter={() => setOpen(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                    My Fast Trade
                  </Link>

                  <div className="dropdown">
                    {open && (
                      <>
                        <button class="dropbtn" onClick={hideSettings}>
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="20"
                            fill="white"
                            class="bi bi-chevron-up"
                            viewBox="0 0 16 16"
                          >
                            {" "}
                            <path
                              fill-rule="evenodd"
                              d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                            />{" "}
                          </svg>{" "}
                        </button>

                        <div className="dropdown-content">
                          <div className="user-info">
                            <p>
                              {sessionuser
                                ? `SALAM ; ${userdata.name}`
                                : "Welcome to Fast Trade"}
                            </p>
                            {sessionuser && <span>{userdata.email}</span>}
                          </div>
                          <hr />
                          <Link to="/setting">
                            <i className="fas fa-cog"></i> Account Details
                          </Link>
                          <hr />
                          <Link to="/notification">
                            <i className="fas fa-bell"></i> Notification
                          </Link>
                          <Link to="/wishlist">
                            <i className="fas fa-heart"></i> Watchlist
                          </Link>
                          <Link to="/mybids">
                            {" "}
                            <i className="fas fa-gavel"></i> My Bid
                          </Link>
                          {/* <Link to="/charges"><i className="fas fa-credit-card"></i> Charges</Link> */}
                          <Link to="/Subscription">
                            <i className="fas fa-crown"></i> My Membership
                          </Link>
                          {sessionuser && (
                            <>
                              <hr />
                              <Link to="/#" className="logout" onClick={logout}>
                                <i className="fas fa-sign-out-alt"></i> Log Out
                              </Link>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </li>
                <li>
                  <span>|</span>
                  <Link to="/notification" style={{ position: "relative" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-bell"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                    </svg>

                    {NotificationCount >= 1 ? (
                      <span className="notification_popup"></span>
                    ) : (
                      ""
                    )}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="middle-icon">
              <Link
                to="/notification"
                style={{ fontSize: "25px", color: "#767676" }}
                className="notification"
              >
                <IoNotificationsOutline size={24} color="#000" />
              </Link>
              <Link
                to=""
                style={{
                  fontSize: "25px",
                  color: "#767676",
                  paddingTop: "3px",
                }}
                className="add"
                onClick={handleClick}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-heart"
                  viewBox="0 0 16 16"
                >
                  <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                </svg>
              </Link>
            </div>
            <div
              className={`sidebar-button mobile-menu-btn ${isOpen ? "active" : ""
                }`}
              onClick={sidemenu}
            >
              <span></span>
            </div>
          </div>
        </header>
      </div>
      <div className="lower-header">
        <div className="lowerbar">
          <div className="top-lowerbar col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
            <p>
              <span>
                {sessionuser
                  ? `SALAM ; ${userdata.name}`
                  : "Welcome to Fast Trade"}
              </span>
            </p>
            <div className="search-form">
              <form
                style={{ width: "100%", position: "relative", display: "flex" }}
                onSubmit={handleSearch}
              >
                <select
                  className="search_select"
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="">All City</option>

                  {locations.map((loc, index) => (
                    <option key={index} value={loc.city_name}>
                      {loc.city_name}
                    </option>
                  ))}
                </select>

                <input
                  type="search"
                  placeholder="Search all of Fast Trade"
                  value={searchword}
                  onChange={handleChange}
                  onFocus={() => setShowDropdown(true)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
                />
                <button type="submit">
                  <IoSearchOutline size={24} color="white" />
                </button>

                {showDropdown && (
                  <ul
                    className="search_list"
                    style={{
                      position: "absolute",
                      backgroundColor: "#ffffff",
                      // border: "1px solid #ddd",
                      borderRadius: "8px",
                      top: "40px",
                      width: "100%",
                      maxHeight: "300px",
                      overflowY: "auto",
                      marginTop: "5px",
                      zIndex: 9999,
                      listStyle: "none",
                      padding: "0",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      transition: "all 0.2s ease-in-out",
                    }}
                  >
                    {/* Recent Searches */}
                    {recentSearches.length > 0 && (
                      <>
                        <li
                          style={{
                            fontWeight: "600",
                            padding: "10px 15px",
                            backgroundColor: "#f0f0f0",
                            borderBottom: "1px solid #ddd",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                          }}
                        >
                          Recent Searches
                        </li>
                        {recentSearches.map((item, index) => (
                          <li
                            key={`recent-${index}`}
                            onClick={() => handleSuggestionClick(item)}
                            style={{
                              padding: "10px 15px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#f9f9f9")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor = "#fff")
                            }
                          >
                            <FontAwesomeIcon
                              icon={faClock}
                              style={{ color: "#888" }}
                            />
                            {item}
                          </li>
                        ))}
                      </>
                    )}

                    {/* Suggestions */}
                    {suggestions.length > 0 && (
                      <>
                        <li
                          style={{
                            fontWeight: "600",
                            padding: "10px 15px",
                            backgroundColor: "#f0f0f0",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          Suggestions
                        </li>
                        {suggestions.map((item) => (
                          <li
                            key={item}
                            onClick={() => handleSuggestionClick(item)}
                            style={{
                              padding: "10px 15px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "#f9f9f9")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor = "#fff")
                            }
                          >
                            <FontAwesomeIcon
                              icon={faSearch}
                              style={{ color: "#888" }}
                            />
                            {item.title}
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                )}
              </form>
            </div>
          </div>
          {/* <div className="top-lowerbar col-12 col-sm-12 col-md-12 col-xl-8">
            <div>
              <span>
                {sessionuser ? (
                  <div>
                    SALAM; {sessionuser.username}
                  </div>
                ) : (
                  "Welcome to Fast Trade"
                )}
              </span>
            </div>
            <div className="search-form">
              <input type="search" placeholder="Search all of Fast Trade" />
              <button>Search</button>
            </div>
          </div> */}

          <div
            className="top-lowerbar img col-4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={`${BASE_URL}/images/header.png`} alt="" />
          </div>
        </div>
        <div
          className="col-12"
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="category">
            <div className=" custom-prev">
              <IoArrowBackOutline size={24} color="black" />
            </div>
            <div className=" custom-next">
              <IoArrowForwardOutline size={24} color="black" />
            </div>
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={5}
              slidesPerView={4}
              navigation={{
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
              }}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              breakpoints={{
                0: { slidesPerView: 1 },
                348: { slidesPerView: 2 },
                448: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
              }}
            >
              {category.map((item, index) => (
                <SwiperSlide
                  key={index}
                  className={index % 2 === 0 ? "color-1" : "color-2"}
                >
                  <div className="category-list">
                    <Link to={`/category/${item.title}`}>
                      <p>{item.title}</p>
                    </Link>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="swiper-navigation">
              <div className=" custom-prev">
                <IoArrowBackOutline size={24} color="black" />
              </div>
              <div className=" custom-next">
                <IoArrowForwardOutline size={24} color="black" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`wishlist-sidebar  ${isActive ? "wishlist-active" : ""}`}>
        <h2
          style={{
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
        >
          <b>Your WatchList</b>{" "}
          <IoCloseSharp size={30} color="black" onClick={handleClick} />
        </h2>
        <br />

        <div style={{ overflow: "scroll", height: "98vh" }}>
          <div className="wish-list">
            {bookmarks.length === 0 ? (
              <>
                <div
                  style={{
                    width: "100%",
                    height: "190px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h4>
                    <b>No Wishlist Found</b>
                  </h4>
                </div>
              </>
            ) : (
              bookmarks.map((item, index) => (
                <>
                  <div className="list" key={index}>
                    <div className="img">
                      <Link to={`/detail/${item.id}`}>
                        <img
                          src={
                            item.photo
                              ? `${BASE_URL}/${item.photo.split(",")[0].trim()}`
                              : `${BASE_URL}/uploads/logo/icon.png`
                          }
                          loading="lazy"
                          alt={item.title || "FastTrade Product"}
                          title={item.title || "FastTrade Product"}
                        />
                      </Link>
                    </div>
                    <div className="info">
                      <h6 style={{ width: "100%" }}>
                        <b
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            width: "90%",
                          }}
                        >
                          <Link to={`/detail/${item.id}`}>{item.title}</Link>
                        </b>
                        <IoSettings
                          size={15}
                          color="black"
                          title="Wishlist Setting"
                          style={{
                            cursor: "pointer",
                            marginLeft: 5,
                            width: "10%",
                          }}
                          onClick={() => toggleMassbox(index)}
                        />
                      </h6>

                      <div className="info-detail">
                        <p>{formatDate(item.closing_time)}</p>
                        {item.buy_now != "0" ? (
                          <p>Buy Now Price: {item.buy_now} SAR</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="bid">
                        <h6>
                          <b>current bid </b>
                        </h6>
                        <h6>
                          <b>
                            {item.current_price} SAR {item.id}
                          </b>
                        </h6>
                      </div>
                    </div>

                    {/* MASSBOX */}
                  </div>
                  <div
                    className={`massbox ${openMassboxIndex === index ? "show" : "hide p-0"
                      }`}
                  >
                    <p>
                      stay informed, and choose a time to be notified. Before
                      Biding ends
                    </p>

                    <div
                      className="whislist_massage"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <select
                        className="form-control"
                        style={{ width: "70%" }}
                        value={messageType}
                        onChange={(e) => setMessageType(e.target.value)}
                      >
                        <option value="Whatsapp">
                          Send me Whatsapp message
                        </option>
                        <option value="Email">Send me Email message</option>
                        <option value="SMS">Send me SMS message</option>
                      </select>

                      <select
                        className="form-control"
                        style={{ width: "30%" }}
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      >
                        <option value="3">3 hour</option>
                        <option value="5">5 hour</option>
                        <option value="7">7 hour</option>
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        marginTop: "10px",
                        fontSize: " clamp(10px, 13px, 20px)",
                      }}
                    >
                      <Link to="/wishlist" style={{ width: "50%" }}>
                        <button>Go to Wishlist </button>
                      </Link>

                      {reminderloader ? (
                        <button style={{ width: "50%" }}>
                          Proccesing......
                        </button>
                      ) : Array.isArray(userreminders) &&
                        userreminders.some(
                          (rem) => Number(rem.item_id) === Number(item.id),
                        ) ? (
                        <button
                          onClick={() => stopreminder(item.id, index, "stop")}
                          style={{ width: "50%" }}
                        >
                          Stop Reminder
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            handleSetReminder(item.id, index, "set")
                          }
                          style={{ width: "50%" }}
                        >
                          Set Reminder
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ))
            )}
          </div>
          <br />
          <h5>
            <b>Similar items</b>
          </h5>
          <div className="swiper-wrapper" style={{ height: "460px" }}>
            <Swiper
              // modules={[Autoplay, Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              // pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              // navigation={{
              //   nextEl: ".auction-slider-prev",
              //   prevEl: ".auction-slider-next",
              // }}
              style={{ height: "460px" }}
              breakpoints={{
                0: {
                  slidesPerView: 1, // 2 slides for small screens (like mobile)
                },
                448: {
                  slidesPerView: 2, // 1 slide for tablets and above
                },
                768: {
                  slidesPerView: 2, // 1 slide for tablets and above
                },
                1200: {
                  slidesPerView: 2, // 1 slide for tablets and above
                },
              }}
            >
              {NewADD.slice(0, 10).map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="auction-card wow animate "
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="auction-card-img-wrap">
                      <Link to={`/detail/${item.id}`} className="card-img">
                        <img
                          src={
                            item.photo
                              ? `${BASE_URL}/${item.photo.split(",")[0].trim()}`
                              : `${BASE_URL}/uploads/logo/icon.png`
                          }
                          loading="lazy"
                          alt={item.title || "FastTrade Product"}
                          title={item.title || "FastTrade Product"}
                        />
                      </Link>
                      <ul className="view-and-favorite-area">
                        <li>
                          <Link to={`/detail/${item.id}`}>
                            <svg
                              width="16"
                              height="15"
                              viewBox="0 0 16 15"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629ZM8.00013 14.8125C-6.375 5.31378 3.57406 -2.09995 7.83512 1.8216C7.89138 1.87317 7.94669 1.9266 8.00013 1.98192C8.05303 1.92665 8.10807 1.87349 8.16513 1.82254C12.4253 -2.10182 22.3753 5.31284 8.00013 14.8125Z"></path>
                            </svg>
                          </Link>
                        </li>
                      </ul>
                      {/* <CountdownTimer closingTime={item.closing_time} /> */}
                    </div>
                    <div className="auction-card-content">
                      <h6>
                        <Link to={`/detail/${item.id}`}>
                          {item.title ||
                            "Vintage valor embracing the elegance of eras past."}
                        </Link>
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <span>Current Bid at:</span>
                          <strong>{item.current_price || "2,898"} SAR</strong>
                        </div>
                        <div className="code">
                          <span># {item.id}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="advertisement" style={{ textAlign: "center" }}>
            {ads.length > 0 ? (
              <Link to={ad.link || "#"}>
                <img
                  src={
                    `${BASE_URL}/uploads/ads/${ad.image}` ||
                    "/assets/default-ad.jpg"
                  }
                  alt={ad.title || "Advertisement"}
                  style={{
                    width: "100%",
                    maxHeight: "300px",
                    objectFit: "cover",
                    borderRadius: "2px",
                    transition: "opacity 0.5s ease-in-out",
                  }}
                />
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}
